// import React, { ChangeEvent } from 'react';
import React from 'react';

//-- utils
// import * as utils from './_utils/utils.js'

//! *** Image Loader ***
interface ImageLoaderProps {
    onUpload: (event: React.ClickEvent<HTMLButtonElement>) => void;
}

const ImageLoader: React.FC<ImageLoaderProps> = ({ onUpload }) => {
    return (
        <button type="button" class="upload-button" onClick={onUpload} > Choose Image... </button> 
    );
};

export default ImageLoader;

//! *** NB local ***
/* interface ImageLoaderProps {
    onUpload: (filename: string ,imageUrl: string) => void;
}

const ImageLoader: React.FC<ImageLoaderProps> = ({ onUpload }) => {

    const onFileUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files?.[0];

        if( !file ) {
            onUpload( null ,"" ,null );
            return;
        }

        try {
            utils.setImageConvert( file ,onUpload );
        } catch(err) {
            onUpload( null ,err.message ,null );
            return;
        }
    };

    return (
        <label className="upload-button">
            Choose Image...
            <input type="file" name="uploaded_file" accept="image/*" onChange={onFileUpload} />
        </label>        
    );
};
*/